<template>
  <component 
    class="button" 
    :is="isLink ? 'router-link' : 'button'" 
    :to="isLink ? to : null"
  >
    <span class="button-inner">
      <slot></slot>
    </span>
    <slot name="actions"></slot>
  </component>
</template>

<script>
export default {
  name: 'UiButton',
  props: {
    to: {
      type: String,
      default: null,
    },
  },
  computed: {
    isLink() {
      return !!this.to;
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
